import dayjs from 'dayjs'

import { ChallengeStatus } from '../types'

export const capitalizeFirstLetter = (str: string | undefined) => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
}

export const transformDate = (date: string) => {
  return dayjs(date).format('DD-MM-YYYY')
}

export const translateStatus = (status: string) => {
  switch (status) {
    case ChallengeStatus.ENDED:
      return 'Finalizado'
    case ChallengeStatus.UPCOMING:
      return 'Próximo'
    default:
      return 'Activo'
  }
}
